import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { canAccessRoute } from 'utils/roleAccess';

export default function RequireAccess({ route, children }) {
  const { roles, accesses } = useAuth();

  if (!route) {
    return <Navigate to="/admin/unauthorized" replace />;
  }

  if (!canAccessRoute(route, roles, accesses)) {
    return <Navigate to="/admin/unauthorized" replace />;
  }

  return children;
}
